import { useState, useEffect } from 'react'

export const useDelayUnmount = (isMounted: boolean, delayTime: number) => {
  const [showDiv, setShowDiv] = useState(false)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout
    if (isMounted && !showDiv) {
      setShowDiv(true)
    } else if (!isMounted && showDiv) {
      timeoutId = setTimeout(() => setShowDiv(false), delayTime) //delay our unmount
    }
    return () => clearTimeout(timeoutId) // cleanup mechanism for effects , the use of setTimeout generate a sideEffect
  }, [isMounted, delayTime])

  return showDiv
}
